import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { secondsToHumanTime } from '../../../../utils/time';
import { uniq } from 'lodash';
import Beeper from '../../../general/Beeper';

const ElapsedTime = props => {
  const [timer, setTimer] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(null);
  const [triggerSound, setTriggerSound] = useState(false);
  const [playSound, setPlaySound] = useState(false);
  const [alertedIncidentIds, setAlertedIncidentIds] = useState([]);

  const startTimer = () => {
    if (timer) clearInterval(timer);

    setTimer(setInterval(() => setElapsedTime(Number.parseInt(moment().diff(props.startTime) / 1000)), 1000));
  };

  const beyondTimeLimit = ({ withTrigger }) => {
    // If there is no time limit set, we don't want anything to get triggered
    if (!props.timeLimit) return false;

    const now = moment();
    const beyondTimeLimit = now.isSameOrAfter(props.timeLimit);

    if (withTrigger && beyondTimeLimit && !triggerSound) {
      setTriggerSound(true);
    }

    return beyondTimeLimit;
  };

  const incidentAlreadyBeeped = alertedIncidentIds.includes(props.incidentId);

  const onFinishedPlayingHandler = () => setPlaySound(false);

  useEffect(() => {
    // Override default call to cleanup
    // see https://reactjs.org/docs/hooks-effect.html#effects-with-cleanup
    return function cleanup() {
      setTimer(clearInterval(timer));
    };
  }, []);

  useEffect(() => {
    if (!beyondTimeLimit({ withTrigger: false }) && triggerSound) setTriggerSound(false);
    startTimer();
  }, [props.startTime]);

  useEffect(() => {
    if (incidentAlreadyBeeped) return;

    if (triggerSound) setPlaySound(true);
  }, [triggerSound]);

  useEffect(() => {
    if (playSound) setAlertedIncidentIds(uniq([...alertedIncidentIds, props.incidentId]));
  }, [playSound]);

  useEffect(() => {
    if (!incidentAlreadyBeeped) setTriggerSound(false);
  }, [props.incidentId]);

  if (!elapsedTime) return null;

  const fontColor = beyondTimeLimit({ withTrigger: true }) ? 'red' : 'var(--bs-body-color)';

  return (
    <>
      <Beeper playSound={playSound} onFinishedPlayingHandler={onFinishedPlayingHandler} />
      <h1 className="float-right display-4 fw-bold font-monospace" style={{ color: fontColor }}>
        {secondsToHumanTime(elapsedTime)}
      </h1>
    </>
  );
};

export default ElapsedTime;
